export const countryList = [
  { label: 'United States', value: 'United States' },
  { label: 'Canada', value: 'Canada' },
  { label: 'United Kingdom', value: 'United Kingdom' },
  { label: 'Antilles', value: 'Antilles' },
  { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
  { label: 'Angola', value: 'Angola' },
  { label: 'Afghanistan', value: 'Afghanistan' },
  { label: 'Armenia', value: 'Armenia' },
  { label: 'Antarctica', value: 'Antarctica' },
  { label: 'Albania', value: 'Albania' },
  { label: 'Argentina', value: 'Argentina' },
  { label: 'Austria', value: 'Austria' },
  { label: 'American Samoa', value: 'American Samoa' },
  { label: 'Aruba', value: 'Aruba' },
  { label: 'Azerbaijan', value: 'Azerbaijan' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Algeria', value: 'Algeria' },
  { label: 'Andorra', value: 'Andorra' },
  { label: 'Burkina Faso', value: 'Burkina Faso' },
  { label: 'Bahrain', value: 'Bahrain' },
  { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
  { label: 'Barbados', value: 'Barbados' },
  { label: 'Belgium', value: 'Belgium' },
  { label: 'Bulgaria', value: 'Bulgaria' },
  { label: 'Burundi', value: 'Burundi' },
  { label: 'Benin', value: 'Benin' },
  { label: 'Brunei Darussalam', value: 'Brunei Darussalam' },
  { label: 'Bermuda', value: 'Bermuda' },
  { label: 'Bolivia, Plurinational State of', value: 'Bolivia, Plurinational State of' },
  { label: 'Bonaire, Sint Eustatius and Saba', value: 'Bonaire, Sint Eustatius and Saba' },
  { label: 'Brazil', value: 'Brazil' },
  { label: 'Bahamas', value: 'Bahamas' },
  { label: 'Botswana', value: 'Botswana' },
  { label: 'Bouvet Island', value: 'Bouvet Island' },
  { label: 'Belarus', value: 'Belarus' },
  { label: 'Belize', value: 'Belize' },
  { label: 'Bangladesh', value: 'Bangladesh' },
  { label: 'Bhutan', value: 'Bhutan' },
  { label: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory' },
  { label: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands' },
  { label: 'Congo, the Democratic Republic of the', value: 'Congo, the Democratic Republic of the' },
  { label: 'Congo', value: 'Congo' },
  { label: 'Central African Republic', value: 'Central African Republic' },
  { label: 'Cabo Verde', value: 'Cabo Verde' },
  { label: 'Colombia', value: 'Colombia' },
  { label: 'Cameroon', value: 'Cameroon' },
  { label: 'Czech Republic', value: 'Czech Republic' },
  { label: 'Costa Rica', value: 'Costa Rica' },
  { label: 'China', value: 'China' },
  { label: 'Christmas Island', value: 'Christmas Island' },
  { label: 'Cyprus', value: 'Cyprus' },
  { label: "Côte d'Ivoire", value: "Côte d'Ivoire" },
  { label: 'Cuba', value: 'Cuba' },
  { label: 'Cook Islands', value: 'Cook Islands' },
  { label: 'Curaçao', value: 'Curaçao' },
  { label: 'Chile', value: 'Chile' },
  { label: 'Croatia', value: 'Croatia' },
  { label: 'Cambodia', value: 'Cambodia' },
  { label: 'Comoros', value: 'Comoros' },
  { label: 'Cayman Islands', value: 'Cayman Islands' },
  { label: 'Chad', value: 'Chad' },
  { label: 'Denmark', value: 'Denmark' },
  { label: 'Djibouti', value: 'Djibouti' },
  { label: 'Dominican Republic', value: 'Dominican Republic' },
  { label: 'Dominica', value: 'Dominica' },
  { label: 'Ethiopia', value: 'Ethiopia' },
  { label: 'Ecuador', value: 'Ecuador' },
  { label: 'Egypt', value: 'Egypt' },
  { label: 'Estonia', value: 'Estonia' },
  { label: 'Eritrea', value: 'Eritrea' },
  { label: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { label: 'El Salvador', value: 'El Salvador' },
  { label: 'France', value: 'France' },
  { label: 'Faroe Islands', value: 'Faroe Islands' },
  { label: 'Falkland Islands (Malvinas)', value: 'Falkland Islands (Malvinas)' },
  { label: 'Finland', value: 'Finland' },
  { label: 'Fiji', value: 'Fiji' },
  { label: 'French Guiana', value: 'French Guiana' },
  { label: 'French Polynesia', value: 'French Polynesia' },
  { label: 'French Southern Territories', value: 'French Southern Territories' },
  { label: 'Germany', value: 'Germany' },
  { label: 'Gabon', value: 'Gabon' },
  { label: 'Grenada', value: 'Grenada' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Guernsey', value: 'Guernsey' },
  { label: 'Ghana', value: 'Ghana' },
  { label: 'Gibraltar', value: 'Gibraltar' },
  { label: 'Greenland', value: 'Greenland' },
  { label: 'Gambia', value: 'Gambia' },
  { label: 'Guinea', value: 'Guinea' },
  { label: 'Guadeloupe', value: 'Guadeloupe' },
  { label: 'Greece', value: 'Greece' },
  { label: 'Guatemala', value: 'Guatemala' },
  { label: 'Guam', value: 'Guam' },
  { label: 'Guinea-Bissau', value: 'Guinea-Bissau' },
  { label: 'Guyana', value: 'Guyana' },
  { label: 'Hong Kong', value: 'Hong Kong' },
  { label: 'Heard Island and McDonald Islands', value: 'Heard Island and McDonald Islands' },
  { label: 'Honduras', value: 'Honduras' },
  { label: 'Haiti', value: 'Haiti' },
  { label: 'Hungary', value: 'Hungary' },
  { label: 'Holy See (Vatican City State)', value: 'Holy See (Vatican City State)' },
  { label: 'Indonesia', value: 'Indonesia' },
  { label: 'Ireland', value: 'Ireland' },
  { label: 'Israel', value: 'Israel' },
  { label: 'Isle of Man', value: 'Isle of Man' },
  { label: 'India', value: 'India' },
  { label: 'Iraq', value: 'Iraq' },
  { label: 'Iran, Islamic Republic of', value: 'Iran, Islamic Republic of' },
  { label: 'Iceland', value: 'Iceland' },
  { label: 'Italy', value: 'Italy' },
  { label: 'Jersey', value: 'Jersey' },
  { label: 'Jamaica', value: 'Jamaica' },
  { label: 'Jordan', value: 'Jordan' },
  { label: 'Japan', value: 'Japan' },
  { label: 'Kenya', value: 'Kenya' },
  { label: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { label: 'Kiribati', value: 'Kiribati' },
  { label: "Korea, Democratic People's Republic of", value: "Korea, Democratic People's Republic of" },
  { label: 'Korea, Republic of', value: 'Korea, Republic of' },
  { label: 'Kuwait', value: 'Kuwait' },
  { label: 'Kazakhstan', value: 'Kazakhstan' },
  { label: 'Kosovo', value: 'Kosovo' },
  { label: "Lao People's Democratic Republic", value: "Lao People's Democratic Republic" },
  { label: 'Lebanon', value: 'Lebanon' },
  { label: 'Liechtenstein', value: 'Liechtenstein' },
  { label: 'Liberia', value: 'Liberia' },
  { label: 'Lesotho', value: 'Lesotho' },
  { label: 'Lithuania', value: 'Lithuania' },
  { label: 'Luxembourg', value: 'Luxembourg' },
  { label: 'Latvia', value: 'Latvia' },
  { label: 'Libya', value: 'Libya' },
  { label: 'Micronesia, Federated States of', value: 'Micronesia, Federated States of' },
  { label: 'Morocco', value: 'Morocco' },
  { label: 'Monaco', value: 'Monaco' },
  { label: 'Moldova, Republic of', value: 'Moldova, Republic of' },
  { label: 'Montenegro', value: 'Montenegro' },
  { label: 'Madagascar', value: 'Madagascar' },
  { label: 'Marshall Islands', value: 'Marshall Islands' },
  { label: 'Macedonia, the former Yugoslav Republic of', value: 'Macedonia, the former Yugoslav Republic of' },
  { label: 'Mali', value: 'Mali' },
  { label: 'Myanmar', value: 'Myanmar' },
  { label: 'Mongolia', value: 'Mongolia' },
  { label: 'Macao', value: 'Macao' },
  { label: 'Martinique', value: 'Martinique' },
  { label: 'Mauritania', value: 'Mauritania' },
  { label: 'Montserrat', value: 'Montserrat' },
  { label: 'Malta', value: 'Malta' },
  { label: 'Mauritius', value: 'Mauritius' },
  { label: 'Maldives', value: 'Maldives' },
  { label: 'Malawi', value: 'Malawi' },
  { label: 'Mexico', value: 'Mexico' },
  { label: 'Malaysia', value: 'Malaysia' },
  { label: 'Mozambique', value: 'Mozambique' },
  { label: 'Mayotte', value: 'Mayotte' },
  { label: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
  { label: 'Namibia', value: 'Namibia' },
  { label: 'New Caledonia', value: 'New Caledonia' },
  { label: 'Niger', value: 'Niger' },
  { label: 'Norfolk Island', value: 'Norfolk Island' },
  { label: 'Nigeria', value: 'Nigeria' },
  { label: 'Nicaragua', value: 'Nicaragua' },
  { label: 'Netherlands', value: 'Netherlands' },
  { label: 'Norway', value: 'Norway' },
  { label: 'Nepal', value: 'Nepal' },
  { label: 'Nauru', value: 'Nauru' },
  { label: 'Niue', value: 'Niue' },
  { label: 'New Zealand', value: 'New Zealand' },
  { label: 'Oman', value: 'Oman' },
  { label: 'Panama', value: 'Panama' },
  { label: 'Peru', value: 'Peru' },
  { label: 'Papua New Guinea', value: 'Papua New Guinea' },
  { label: 'Philippines', value: 'Philippines' },
  { label: 'Pakistan', value: 'Pakistan' },
  { label: 'Poland', value: 'Poland' },
  { label: 'Pitcairn', value: 'Pitcairn' },
  { label: 'Puerto Rico', value: 'Puerto Rico' },
  { label: 'Palestine, State of', value: 'Palestine, State of' },
  { label: 'Portugal', value: 'Portugal' },
  { label: 'Palau', value: 'Palau' },
  { label: 'Paraguay', value: 'Paraguay' },
  { label: 'Qatar', value: 'Qatar' },
  { label: 'Réunion', value: 'Réunion' },
  { label: 'Romania', value: 'Romania' },
  { label: 'Russian Federation', value: 'Russian Federation' },
  { label: 'Rwanda', value: 'Rwanda' },
  { label: 'Switzerland', value: 'Switzerland' },
  { label: 'Saint Barthélemy', value: 'Saint Barthélemy' },
  { label: 'Serbia and Montenegro', value: 'Serbia and Montenegro' },
  { label: 'Spain', value: 'Spain' },
  { label: 'South Georgia and the South Sandwich Islands', value: 'South Georgia and the South Sandwich Islands' },
  { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
  { label: 'Saint Lucia', value: 'Saint Lucia' },
  { label: 'Sri Lanka', value: 'Sri Lanka' },
  { label: 'Saint Martin (French part)', value: 'Saint Martin (French part)' },
  { label: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon' },
  { label: 'Serbia', value: 'Serbia' },
  { label: 'Saudi Arabia', value: 'Saudi Arabia' },
  { label: 'Solomon Islands', value: 'Solomon Islands' },
  { label: 'Seychelles', value: 'Seychelles' },
  { label: 'Sudan', value: 'Sudan' },
  { label: 'Sweden', value: 'Sweden' },
  { label: 'Singapore', value: 'Singapore' },
  { label: 'Saint Helena, Ascension and Tristan da Cunha', value: 'Saint Helena, Ascension and Tristan da Cunha' },
  { label: 'Slovenia', value: 'Slovenia' },
  { label: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen' },
  { label: 'Slovakia', value: 'Slovakia' },
  { label: 'Sierra Leone', value: 'Sierra Leone' },
  { label: 'San Marino', value: 'San Marino' },
  { label: 'Senegal', value: 'Senegal' },
  { label: 'Somalia', value: 'Somalia' },
  { label: 'Suriname', value: 'Suriname' },
  { label: 'South Sudan', value: 'South Sudan' },
  { label: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
  { label: 'Sint Maarten (Dutch part)', value: 'Sint Maarten (Dutch part)' },
  { label: 'Syrian Arab Republic', value: 'Syrian Arab Republic' },
  { label: 'Swaziland', value: 'Swaziland' },
  { label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' },
  { label: 'Samoa', value: 'Samoa' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands' },
  { label: 'Togo', value: 'Togo' },
  { label: 'Thailand', value: 'Thailand' },
  { label: 'Tajikistan', value: 'Tajikistan' },
  { label: 'Tokelau', value: 'Tokelau' },
  { label: 'Timor-Leste', value: 'Timor-Leste' },
  { label: 'Turkmenistan', value: 'Turkmenistan' },
  { label: 'Tunisia', value: 'Tunisia' },
  { label: 'Tonga', value: 'Tonga' },
  { label: 'Turkey', value: 'Turkey' },
  { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
  { label: 'Tuvalu', value: 'Tuvalu' },
  { label: 'Taiwan, Province of China', value: 'Taiwan, Province of China' },
  { label: 'Tanzania, United Republic of', value: 'Tanzania, United Republic of' },
  { label: 'Ukraine', value: 'Ukraine' },
  { label: 'Uganda', value: 'Uganda' },
  { label: 'United Arab Emirates', value: 'United Arab Emirates' },
  { label: 'United States Minor Outlying Islands', value: 'United States Minor Outlying Islands' },
  { label: 'Uruguay', value: 'Uruguay' },
  { label: 'Uzbekistan', value: 'Uzbekistan' },
  { label: 'Venezuela, Bolivarian Republic of', value: 'Venezuela, Bolivarian Republic of' },
  { label: 'Virgin Islands, British', value: 'Virgin Islands, British' },
  { label: 'Virgin Islands, U.S.', value: 'Virgin Islands, U.S.' },
  { label: 'Viet Nam', value: 'Viet Nam' },
  { label: 'Vanuatu', value: 'Vanuatu' },
  { label: 'Western Sahara', value: 'Western Sahara' },
  { label: 'Wallis and Futuna', value: 'Wallis and Futuna' },
  { label: 'Yemen', value: 'Yemen' },
  { label: 'Zambia', value: 'Zambia' },
  { label: 'Zimbabwe', value: 'Zimbabwe' },
  { label: 'Åland Islands', value: 'Åland Islands' },
];

export const experienceLevelOptions = [
  { label: 'Junior', value: 'Junior' },
  { label: 'Mid-Level', value: 'Mid-Level' },
  { label: 'Senior', value: 'Senior' },
];

export const industryOptions = [
  { label: 'Software', value: 'Software' },
  { label: 'Financial Services/Insurance', value: 'Financial Services/Insurance' },
  { label: 'Health Care Services', value: 'Health Care Services' },
  { label: 'Consulting', value: 'Consulting' },
  { label: 'Manufacturing/Consumer Goods', value: 'Manufacturing/Consumer Goods' },
  { label: 'Internet Services', value: 'Internet Services' },
  { label: 'Electronics/Semiconductors', value: 'Electronics/Semiconductors' },
  { label: 'Education', value: 'Education' },
  { label: 'Industrial Products/Manufacturing', value: 'Industrial Products/Manufacturing' },
  { label: 'Advertising/Marketing Services', value: 'Advertising/Marketing Services' },
  { label: 'Utilities', value: 'Utilities' },
  { label: 'Government', value: 'Government' },
  { label: 'Transportation', value: 'Transportation' },
  { label: 'Retail/Wholesale', value: 'Retail/Wholesale' },
  { label: 'Entertainment/Leisure', value: 'Entertainment/Leisure' },
  { label: 'Construction/Engineering/Manufacturing', value: 'Construction/Engineering/Manufacturing' },
  { label: 'Agriculture/Food/Beverages', value: 'Agriculture/Food/Beverages' },
];

export const jobFunctionOptions = [
  { label: 'Accounting/Finance', value: 'Accounting/Finance' },
  { label: 'Administrative', value: 'Administrative' },
  { label: 'Business Development', value: 'Business Development' },
  { label: 'Consulting', value: 'Consulting' },
  { label: 'Customer Service', value: 'Customer Service' },
  { label: 'Distribution', value: 'Distribution' },
  { label: 'Engineering', value: 'Engineering' },
  { label: 'General Management', value: 'General Management' },
  { label: 'Human Resources', value: 'Human Resources' },
  { label: 'Information Technology', value: 'Information Technology' },
  { label: 'Legal', value: 'Legal' },
  { label: 'Manufacturing', value: 'Manufacturing' },
  { label: 'Marketing', value: 'Marketing' },
  { label: 'Operations', value: 'Operations' },
  { label: 'Product Management', value: 'Product Management' },
  { label: 'Professional Services', value: 'Professional Services' },
  { label: 'Public Relations', value: 'Public Relations' },
  { label: 'Purchasing', value: 'Purchasing' },
  { label: 'Quality Assurance', value: 'Quality Assurance' },
  { label: 'Research and Development', value: 'Research and Development' },
  { label: 'Sales', value: 'Sales' },
];

export const prefixOptions = [
  { label: 'Dr.', value: 'Dr.' },
  { label: 'Mr.', value: 'Mr.' },
  { label: 'Ms.', value: 'Ms.' },
  { label: 'Mrs.', value: 'Mrs.' },
  { label: 'Professor', value: 'Professor' },
  { label: 'Mx.', value: 'Mx.' },
  { label: 'Prefer not to say', value: 'Prefer not to say' },
];

export const eeaCountries = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Canada',
  'China',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Iceland',
  'Ireland',
  'Italy',
  'Latvia',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Switzerland',
  'United Kingdom',
];
